import { gsap, Power3 } from 'gsap';

import Win from './Window';
import { GetBy } from '../core/Element';

class Person extends Win {
  content;

  constructor(__container) {
    super(__container, 'Person');
    this.directHide();

    this.content = GetBy.class('__content', this.container)[0];
  }

  actionButtonToggle(item) {
    console.log(item);

    this.text(item.dataset.description);
    this.toggleState();
  }

  text(__text) {
    this.content.innerHTML = __text;
  }

  show__effect(__d = 0) {
    gsap.to(this.container, { opacity: 1, duration: .4, ease: Power3.easeOut, onComplete: () => { this.afterShow() } });
  }

  afterShow() {
    super.afterShow();
    this.container.style.pointerEvents = 'initial';
  }

  hide__effect(__d = 0) {
    gsap.to(this.container, { opacity: 0, duration: .1, ease: Power3.easeOut, onComplete: () => { this.afterHide(); } });
  }

  beforeHide() {
    super.beforeHide();
    this.container.style.pointerEvents = 'none';
  }

  afterHide() {
    super.afterHide();
    if (this.content) this.content.innerHTML = '';
  }

  directHide() {
    gsap.set(this.container, { opacity: 0 });
    super.directHide();
  }
}

export const WinPerson = new Person(GetBy.id('Person'));
